// extracted by mini-css-extract-plugin
export default {"inputscreen":"InputScreen_inputscreen__ZiS4o"};